import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IHomeIconProps extends ISvgIconProps {

}

export class HomeIcon extends React.Component<IHomeIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M18.5,21.5h-4.6c-0.6,0-1.1-0.5-1.1-1.1v-4.1h-1.5v4.1c0,0.6-0.5,1.1-1.1,1.1H5.5c-0.6,0-1.1-0.5-1.1-1.1v-7.1H3.6
                        c-0.6,0-1.2-0.4-1.4-1c-0.2-0.6-0.1-1.3,0.4-1.7L11,2.9c0.6-0.5,1.5-0.5,2.1,0L14.3,4c0.2-0.2,0.5-0.4,0.8-0.4h3.8
                        c0.6,0,1.1,0.5,1.1,1.1v4.5l1.4,1.3c0.5,0.4,0.6,1.1,0.4,1.7c-0.2,0.6-0.8,1-1.4,1h-0.8v7.1C19.7,21,19.2,21.5,18.5,21.5z
                        M10.1,15.1h3.9v5.3l4.6,0l0-8.2h1.9c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0-0.3-0.1-0.4l0.4-0.4l-0.4,0.4l-1.8-1.6v-5l-3.8,0l0,0.3v1.3
                        l-2.9-2.6c-0.1-0.1-0.4-0.1-0.5,0l-8.4,7.7c-0.1,0.1-0.2,0.3-0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2h1.9v8.3l4.6,0L10.1,15.1z"/>
                    {/* <path d="M20.825,12.501c-0.176,0-0.347-0.062-0.482-0.175l-8.252-6.921l-8.252,6.921c-0.301,0.272-0.811,0.232-1.065-0.085
                        c-0.267-0.306-0.22-0.814,0.101-1.064c0,0,8.734-7.325,8.734-7.325c0.135-0.113,0.306-0.175,0.482-0.175s0.347,0.062,0.482,0.175
                        l8.734,7.325C21.839,11.594,21.507,12.527,20.825,12.501L20.825,12.501z"/>
                    <path d="M19.415,9.121c-0.403,0.008-0.758-0.347-0.75-0.75c0,0,0-2.631,0-2.631h-1.317c0.09,1.047-1.466,1.151-1.5,0.1
                        c0,0,0-0.85,0-0.85c-0.008-0.403,0.347-0.758,0.75-0.75c0,0,2.817,0,2.817,0c0.403-0.008,0.758,0.347,0.75,0.75c0,0,0,3.381,0,3.381
                        C20.173,8.774,19.818,9.129,19.415,9.121z"/>
                    <path d="M19.417,20.954h-5.072c-0.199,0-0.39-0.079-0.53-0.22c-0.141-0.141-0.22-0.331-0.22-0.53v-5.167h-3.008v5.167
                        c0,0.199-0.079,0.39-0.22,0.53c-0.141,0.141-0.331,0.22-0.53,0.22H4.766c-0.403,0.008-0.758-0.347-0.75-0.75c0,0,0-7.325,0-7.325
                        c0.004-0.978,1.495-0.982,1.5,0c0,0,0,6.575,0,6.575h3.571v-5.167c-0.008-0.403,0.347-0.758,0.75-0.75c0,0,4.508,0,4.508,0
                        c0.199,0,0.39,0.079,0.53,0.22c0.141,0.141,0.22,0.331,0.22,0.53v5.167h3.571v-6.575c0.004-0.979,1.496-0.982,1.5,0
                        c0,0,0,7.325,0,7.325C20.174,20.606,19.82,20.961,19.417,20.954z"/> */}
                </g>
            </SvgIcon>
        );
    }
}
